module.exports = __webpack_public_path__ + "img/ico-chufa@2x.26ed2625.png";